import React from "react";

export const BtnSua = ({ item ,onEdit }) => {

    return (
            <a href="#!" type="button" className="popover-basic" onClick={() => onEdit(item)} title="Sửa">
                <img src="/app-assets/images/icon-edit-v2.png" alt="Sửa" />
            </a>
    );
};